import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCommonColors } from "octalog-base";

import { QUERY_KEY_PRICES } from "../../common/Constants";
import { tryToExtractDescription } from "../../common/error/ErrorMessageUtil";
import {
  setPriceSettingsMutation,
  getPriceSettingsQueryKey,
} from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export const usePriceSettingsMutation = () => {
  const commonColors = useCommonColors();
  const queryClient = useQueryClient();

  return useMutation({
    ...setPriceSettingsMutation(),
    onSuccess: () => {
      // noinspection JSIgnoredPromiseFromCall
      queryClient.invalidateQueries({
        queryKey: getPriceSettingsQueryKey(),
      });
      // noinspection JSIgnoredPromiseFromCall
      queryClient.invalidateQueries({
        queryKey: QUERY_KEY_PRICES,
      });
      notifications.show({
        title: "Erfolg",
        message: `Preisverwaltung wurde erfolgreich aktualisiert!`,
        color: commonColors.greenPrimary,
      });
    },
    onError: (error: Error) => {
      notifications.show({
        title: "Fehler",
        message: `Preisverwaltung konnte nicht aktualisiert werden: ${tryToExtractDescription(error)}`,
        color: commonColors.redPrimary,
      });
    },
  });
};
